module.exports = __webpack_public_path__ + "static/media/arrowLeft.4db99c00.svg";